/**
 * TRANSLATIONS - Multi-language support
 * Languages: EN (default), HR, DE, PL, CS, HU, SL, SK, IT, FR
 */

export const languages = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'hr', name: 'Hrvatski', flag: '🇭🇷' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'pl', name: 'Polski', flag: '🇵🇱' },
  { code: 'cs', name: 'Čeština', flag: '🇨🇿' },
  { code: 'hu', name: 'Magyar', flag: '🇭🇺' },
  { code: 'sl', name: 'Slovenščina', flag: '🇸🇮' },
  { code: 'sk', name: 'Slovenčina', flag: '🇸🇰' },
];

export const translations = {
  en: {
    // Navigation
    nav: {
      gallery: "Gallery",
      about: "About",
      location: "Location",
      attractions: "What to Visit",
      faq: "FAQ",
      contact: "Contact",
      sendInquiry: "Send Inquiry",
    },
    // Hero
    hero: {
      welcome: "Welcome to paradise on the Adriatic",
      title1: "Apartments",
      title2: "Adriatic & Maestral",
      tagline: "Beachfront accommodation near Orebić with sea view",
      features: ["Sea View", "Beachfront", "Free WiFi"],
    },
    // Gallery
    gallery: {
      subtitle: "Gallery",
      title: "View our apartments",
      enlarge: "Enlarge",
    },
    // About
    about: {
      subtitle: "About Apartments",
      title: "Everything you need for a perfect vacation",
      description: "Apartments Adriatic and Maestral offer beachfront accommodation near Orebić with a beautiful sea view. Guests can enjoy the sunny terrace. Both apartments have air conditioning, private bathrooms with free toiletries, and fully equipped kitchens. Additional amenities include terraces, free WiFi, smart TV, etc. Private parking spaces are also available.",
    },
    // Location
    location: {
      subtitle: "Location",
      title: "Where we are located",
      address: "Address",
      description: "The apartments are located in the peaceful village of Borje, near Orebić on the Pelješac peninsula. Beautiful beaches are just steps away from the apartments, and you can reach hidden, enchanting coves by SUP board (available upon request). On the beautiful apartment terraces, you can enjoy your morning coffee or evening sea view, while on the beach you can read a book in the pleasant shade of pine trees.\n\nOrebić is just 8 minutes away by car, and from there it's an additional 15 minutes by boat to Korčula. Nature lovers can enjoy an unforgettable hike to the highest peak of Pelješac, Sv. Ilija, or take a boat to Mljet National Park and Lastovo Nature Park.\n\nFor those seeking active holidays and adrenaline, nearby is Viganj — a true paradise for surfers and one of the most famous windsurfing and kitesurfing spots on the Adriatic. Dubrovnik is about 80 minutes away by car.\n\nIdeal for all who seek peace, a beautiful view of the sea and islands, and an authentic Dalmatian experience, with the possibility of sports adventures nearby.",
      openMaps: "Open in Google Maps",
    },
    // Attractions
    attractions: {
      subtitle: "Explore the Area",
      title: "What to Visit?",
      description: "Near the apartment are beautiful destinations you must visit",
      places: {
        orebic: {
          name: "Orebić",
          description: "A beautiful Dalmatian town known for its long maritime tradition, beautiful beaches and views of Korčula. Walk along the waterfront, visit the Franciscan monastery or enjoy local gastronomy.",
          distance: "8 min drive",
        },
        viganj: {
          name: "Viganj",
          description: "Paradise for surfers and water sports enthusiasts! Viganj is known as one of the best European destinations for windsurfing and kitesurfing thanks to the ideal Maestral winds.",
          distance: "15 min drive",
        },
        korcula: {
          name: "Korčula",
          description: "\"Little Dubrovnik\" - a medieval town surrounded by walls, birthplace of Marco Polo. Explore narrow streets, cathedrals and enjoy the evening atmosphere by the sea.",
          distance: "15 min by boat from Orebić",
        },
        mljet: {
          name: "Mljet National Park",
          description: "The greenest Croatian island with two salt lakes, a Benedictine monastery on an islet and untouched nature. Ideal for swimming, kayaking and enjoying peace.",
          distance: "1h by boat",
        },
        svIlija: {
          name: "Sv. Ilija - Highest Peak of Pelješac",
          description: "An unforgettable hike to the peak at 961m with a panoramic view of the entire peninsula, islands and the Adriatic Sea. The trail starts from Orebić through pine forest.",
          distance: "2h hike from Orebić",
        },
        dubrovnik: {
          name: "Dubrovnik",
          description: "Pearl of the Adriatic and UNESCO World Heritage Site. Walk the famous walls, explore Stradun, visit Lovrijenac fortress or refresh yourself at Banje beach. A must-see destination!",
          distance: "80 min drive",
        },
      },
    },
    // FAQ
    faq: {
      subtitle: "FAQ",
      title: "Frequently Asked Questions",
      items: [
        {
          question: "What are the check-in and check-out times?",
          answer: "Check-in is from 14:00 to 23:00. Check-out is from 06:00 to 11:00. Please let us know in advance when you plan to arrive.",
        },
        {
          question: "Can I bring a pet?",
          answer: "Unfortunately, pets are not allowed in the apartment.",
        },
        {
          question: "Does the apartment have parking?",
          answer: "Yes, the apartment has free parking space for guests.",
        },
        {
          question: "Is smoking allowed?",
          answer: "Smoking is not allowed inside the apartment. You can smoke on the outdoor terrace.",
        },
      ],
    },
    // Contact
    contact: {
      subtitle: "Contact",
      title: "Get in Touch",
      phone: "Phone",
      email: "Email",
      whatsapp: "Message us",
    },
    // Inquiry Form
    inquiry: {
      subtitle: "Reservation",
      title: "Send Inquiry",
      description: "Fill out the form and we will get back to you with an offer as soon as possible.",
      checkIn: "Check-in Date *",
      checkOut: "Check-out Date *",
      selectDate: "Select date",
      guests: "Number of Guests *",
      selectGuests: "Select number of guests",
      person: "person",
      persons: "persons",
      fullName: "Full Name *",
      fullNamePlaceholder: "Your full name",
      emailLabel: "Email *",
      emailPlaceholder: "your@email.com",
      message: "Message (optional)",
      messagePlaceholder: "Additional notes or questions...",
      consent: "I agree to the processing of personal data for inquiry purposes *",
      submit: "Send Inquiry",
      sending: "Sending...",
      successTitle: "Thank you for your inquiry!",
      successMessage: "We will get back to you soon.",
      errorTitle: "Error sending inquiry",
      errorMessage: "Please try again or contact us by phone.",
    },
    // Footer
    footer: {
      quickLinks: "Quick Links",
      contact: "Contact",
      rights: "All rights reserved.",
      privacy: "Privacy Policy | Terms of Use",
    },
  },

  hr: {
    nav: {
      gallery: "Galerija",
      about: "O apartmanima",
      location: "Lokacija",
      attractions: "Što posjetiti",
      faq: "FAQ",
      contact: "Kontakt",
      sendInquiry: "Pošalji upit",
    },
    hero: {
      welcome: "Dobrodošli u raj na Jadranu",
      title1: "Apartmani",
      title2: "Adriatic & Maestral",
      tagline: "Smještaj uz plažu u blizini Orebića s pogledom na more",
      features: ["Pogled na more", "Uz plažu", "Besplatan WiFi"],
    },
    gallery: {
      subtitle: "Galerija",
      title: "Pogledajte naše apartmane",
      enlarge: "Povećaj",
    },
    about: {
      subtitle: "O apartmanima",
      title: "Sve što trebate za savršen odmor",
      description: "Apartmani Adriatic i Maestral nude smještaj uz plažu u blizini Orebića s prekrasnim pogledom na more. Gosti mogu uživati na sunčanoj terasi. Oba apartmana imaju klimu, privatne kupaonice s besplatnim priborom za higijenu i potpuno opremljene kuhinje. Dodatne pogodnosti koje posjeduju oba apartmana su terase, besplatni WiFi, smart TV, itd. Također, na raspolaganju su i privatna parking mjesta.",
    },
    location: {
      subtitle: "Lokacija",
      title: "Gdje se nalazimo",
      address: "Adresa",
      description: "Apartmani se nalaze u mirnom mjestu Borje, u blizini Orebića na poluotoku Pelješcu. Prekrasne plaže smještene su nadomak apartmana, a do skrivenih, očaravajućih uvala možete stići SUP daskom (koju možete dobiti na upit). Na prekrasnim terasama apartmana možete uživati u jutarnjoj kavi ili večernjem pogledu na more, dok na plaži možete čitati knjigu u ugodnoj hladovini borova.\n\nDo Orebića vam je potrebno svega 8 minuta vožnje automobilom, a odatle za dodatnih 15 minuta brodicom stižete do Korčule. Ljubitelji prirode mogu uživati u nezaboravnom planinarenju do najvišeg vrha Pelješca, Sv. Ilije, ili se uputiti brodicom prema Nacionalnom parku Mljet i Parku prirode Lastovo.\n\nZa one željne aktivnog odmora i adrenalina, u blizini se nalazi i Viganj — pravi raj za surfere i jedno od najpoznatijih mjesta za windsurfing i kitesurfing na Jadranu. Dubrovnik je udaljen oko 80 minuta vožnje automobilom.\n\nIdealno za sve koji traže mir, prekrasan pogled na more i otoke te autentičan dalmatinski doživljaj, uz mogućnost sportskih avantura u blizini.",
      openMaps: "Otvori u Google Maps",
    },
    attractions: {
      subtitle: "Istražite okolicu",
      title: "Što posjetiti?",
      description: "U blizini apartmana nalaze se prekrasne destinacije koje morate posjetiti",
      places: {
        orebic: {
          name: "Orebić",
          description: "Prekrasni dalmatinski gradić poznat po dugoj pomorskoj tradiciji, prekrasnim plažama i pogledu na Korčulu. Prošetajte rivom, posjetite Franjevački samostan ili uživajte u lokalnoj gastronomiji.",
          distance: "8 min vožnje",
        },
        viganj: {
          name: "Viganj",
          description: "Raj za surfere i ljubitelje vodenih sportova! Viganj je poznat kao jedna od najboljih europskih destinacija za windsurfing i kitesurfing zahvaljujući idealnim vjetrovima Maestralu.",
          distance: "15 min vožnje",
        },
        korcula: {
          name: "Korčula",
          description: "\"Mali Dubrovnik\" - srednjovjekovni grad okružen zidinama, rodno mjesto Marka Pola. Istražite uske uličice, katedrale i uživajte u večernjoj atmosferi uz more.",
          distance: "15 min brodicom iz Orebića",
        },
        mljet: {
          name: "Nacionalni park Mljet",
          description: "Najzeleniji hrvatski otok s dva slana jezera, benediktinskim samostanom na otočiću i netaknutom prirodom. Idealno za kupanje, vožnju kajakom i uživanje u miru.",
          distance: "1h brodicom",
        },
        svIlija: {
          name: "Sv. Ilija - najviši vrh Pelješca",
          description: "Nezaboravno planinarenje do vrha na 961m s panoramskim pogledom na cijeli poluotok, otoke i Jadransko more. Staza kreće iz Orebića kroz borovu šumu.",
          distance: "2h planinarenja iz Orebića",
        },
        dubrovnik: {
          name: "Dubrovnik",
          description: "Biser Jadrana i UNESCO-va svjetska baština. Prošetajte poznatim zidinama, istražite Stradun, posjetite tvrđavu Lovrijenac ili se osvježite na plaži Banje. Nezaobilazna destinacija!",
          distance: "80 min vožnje",
        },
      },
    },
    faq: {
      subtitle: "FAQ",
      title: "Često postavljana pitanja",
      items: [
        {
          question: "Kada je vrijeme dolaska i odlaska?",
          answer: "Check-in je od 14:00 do 23:00 sata. Check-out je od 06:00 do 11:00 sati. Molimo javite nam unaprijed kada planirate doći.",
        },
        {
          question: "Može li se doći s kućnim ljubimcem?",
          answer: "Nažalost, kućni ljubimci nisu dozvoljeni u apartmanu.",
        },
        {
          question: "Ima li apartman parking?",
          answer: "Da, apartman ima osigurano besplatno parkirno mjesto za goste.",
        },
        {
          question: "Je li dopušteno pušenje?",
          answer: "Pušenje nije dozvoljeno u apartmanu. Možete pušiti na vanjskoj terasi.",
        },
      ],
    },
    contact: {
      subtitle: "Kontakt",
      title: "Javite nam se",
      phone: "Telefon",
      email: "Email",
      whatsapp: "Pišite nam",
    },
    inquiry: {
      subtitle: "Rezervacija",
      title: "Pošaljite upit",
      description: "Ispunite obrazac i javit ćemo vam se s ponudom u najkraćem roku.",
      checkIn: "Datum dolaska *",
      checkOut: "Datum odlaska *",
      selectDate: "Odaberite datum",
      guests: "Broj osoba *",
      selectGuests: "Odaberite broj osoba",
      person: "osoba",
      persons: "osobe",
      fullName: "Ime i prezime *",
      fullNamePlaceholder: "Vaše ime i prezime",
      emailLabel: "Email *",
      emailPlaceholder: "vas@email.com",
      message: "Poruka (opcionalno)",
      messagePlaceholder: "Dodatne napomene ili pitanja...",
      consent: "Slažem se s obradom osobnih podataka u svrhu obrade upita *",
      submit: "Pošalji upit",
      sending: "Šaljem...",
      successTitle: "Hvala na upitu!",
      successMessage: "Javit ćemo vam se uskoro.",
      errorTitle: "Greška pri slanju upita",
      errorMessage: "Molimo pokušajte ponovo ili nas kontaktirajte telefonom.",
    },
    footer: {
      quickLinks: "Brzi linkovi",
      contact: "Kontakt",
      rights: "Sva prava pridržana.",
      privacy: "Politika privatnosti | Uvjeti korištenja",
    },
  },

  de: {
    nav: {
      gallery: "Galerie",
      about: "Über uns",
      location: "Standort",
      attractions: "Sehenswürdigkeiten",
      faq: "FAQ",
      contact: "Kontakt",
      sendInquiry: "Anfrage senden",
    },
    hero: {
      welcome: "Willkommen im Paradies an der Adria",
      title1: "Apartments",
      title2: "Adriatic & Maestral",
      tagline: "Unterkunft am Strand in der Nähe von Orebić mit Meerblick",
      features: ["Meerblick", "Am Strand", "Kostenloses WLAN"],
    },
    gallery: {
      subtitle: "Galerie",
      title: "Sehen Sie unsere Apartments",
      enlarge: "Vergrößern",
    },
    about: {
      subtitle: "Über die Apartments",
      title: "Alles, was Sie für einen perfekten Urlaub brauchen",
      description: "Die Apartments Adriatic und Maestral bieten Unterkunft am Strand in der Nähe von Orebić mit wunderschönem Meerblick. Gäste können die sonnige Terrasse genießen. Beide Apartments verfügen über Klimaanlage, private Badezimmer mit kostenlosen Pflegeprodukten und voll ausgestattete Küchen. Weitere Annehmlichkeiten sind Terrassen, kostenloses WLAN, Smart-TV usw. Private Parkplätze stehen ebenfalls zur Verfügung.",
    },
    location: {
      subtitle: "Standort",
      title: "Wo wir uns befinden",
      address: "Adresse",
      description: "Die Apartments befinden sich im ruhigen Dorf Borje, in der Nähe von Orebić auf der Halbinsel Pelješac. Wunderschöne Strände befinden sich in unmittelbarer Nähe der Apartments, und versteckte, bezaubernde Buchten erreichen Sie mit dem SUP-Board (auf Anfrage erhältlich). Auf den wunderschönen Terrassen der Apartments können Sie Ihren Morgenkaffee oder den abendlichen Meerblick genießen, während Sie am Strand ein Buch im angenehmen Schatten der Pinien lesen können.\n\nOrebić ist nur 8 Autominuten entfernt, und von dort sind es weitere 15 Minuten mit dem Boot nach Korčula. Naturliebhaber können eine unvergessliche Wanderung zum höchsten Gipfel von Pelješac, Sv. Ilija, genießen oder mit dem Boot zum Nationalpark Mljet und zum Naturpark Lastovo fahren.\n\nFür diejenigen, die aktiven Urlaub und Adrenalin suchen, liegt in der Nähe Viganj — ein wahres Paradies für Surfer und einer der berühmtesten Windsurfing- und Kitesurfing-Spots an der Adria. Dubrovnik ist etwa 80 Autominuten entfernt.\n\nIdeal für alle, die Ruhe, einen wunderschönen Blick auf das Meer und die Inseln sowie ein authentisches dalmatinisches Erlebnis suchen, mit der Möglichkeit von Sportabenteuern in der Nähe.",
      openMaps: "In Google Maps öffnen",
    },
    attractions: {
      subtitle: "Erkunden Sie die Umgebung",
      title: "Was besuchen?",
      description: "In der Nähe der Apartments befinden sich wunderschöne Reiseziele, die Sie besuchen müssen",
      places: {
        orebic: {
          name: "Orebić",
          description: "Eine wunderschöne dalmatinische Stadt, bekannt für ihre lange Seefahrtstradition, wunderschöne Strände und Blick auf Korčula. Spazieren Sie entlang der Uferpromenade, besuchen Sie das Franziskanerkloster oder genießen Sie die lokale Gastronomie.",
          distance: "8 Min. Fahrt",
        },
        viganj: {
          name: "Viganj",
          description: "Paradies für Surfer und Wassersportbegeisterte! Viganj ist dank der idealen Maestral-Winde als eines der besten europäischen Ziele für Windsurfen und Kitesurfen bekannt.",
          distance: "15 Min. Fahrt",
        },
        korcula: {
          name: "Korčula",
          description: "\"Klein Dubrovnik\" - eine mittelalterliche Stadt, umgeben von Mauern, Geburtsort von Marco Polo. Erkunden Sie enge Gassen, Kathedralen und genießen Sie die Abendatmosphäre am Meer.",
          distance: "15 Min. mit dem Boot von Orebić",
        },
        mljet: {
          name: "Nationalpark Mljet",
          description: "Die grünste kroatische Insel mit zwei Salzseen, einem Benediktinerkloster auf einer Insel und unberührter Natur. Ideal zum Schwimmen, Kajakfahren und zum Genießen der Ruhe.",
          distance: "1 Std. mit dem Boot",
        },
        svIlija: {
          name: "Sv. Ilija - Höchster Gipfel von Pelješac",
          description: "Eine unvergessliche Wanderung zum 961m hohen Gipfel mit Panoramablick auf die gesamte Halbinsel, Inseln und die Adria. Der Weg beginnt in Orebić durch den Kiefernwald.",
          distance: "2 Std. Wanderung von Orebić",
        },
        dubrovnik: {
          name: "Dubrovnik",
          description: "Perle der Adria und UNESCO-Weltkulturerbe. Spazieren Sie auf den berühmten Mauern, erkunden Sie den Stradun, besuchen Sie die Festung Lovrijenac oder erfrischen Sie sich am Strand Banje. Ein Muss!",
          distance: "80 Min. Fahrt",
        },
      },
    },
    faq: {
      subtitle: "FAQ",
      title: "Häufig gestellte Fragen",
      items: [
        {
          question: "Wann ist Check-in und Check-out?",
          answer: "Check-in ist von 14:00 bis 23:00 Uhr. Check-out ist von 06:00 bis 11:00 Uhr. Bitte teilen Sie uns im Voraus mit, wann Sie ankommen möchten.",
        },
        {
          question: "Kann ich ein Haustier mitbringen?",
          answer: "Leider sind Haustiere in der Wohnung nicht erlaubt.",
        },
        {
          question: "Hat die Wohnung einen Parkplatz?",
          answer: "Ja, die Wohnung verfügt über einen kostenlosen Parkplatz für Gäste.",
        },
        {
          question: "Ist Rauchen erlaubt?",
          answer: "Rauchen ist in der Wohnung nicht gestattet. Sie können auf der Außenterrasse rauchen.",
        },
      ],
    },
    contact: {
      subtitle: "Kontakt",
      title: "Kontaktieren Sie uns",
      phone: "Telefon",
      email: "E-Mail",
      whatsapp: "Schreiben Sie uns",
    },
    inquiry: {
      subtitle: "Reservierung",
      title: "Anfrage senden",
      description: "Füllen Sie das Formular aus und wir werden uns so schnell wie möglich mit einem Angebot bei Ihnen melden.",
      checkIn: "Anreisedatum *",
      checkOut: "Abreisedatum *",
      selectDate: "Datum auswählen",
      guests: "Anzahl der Gäste *",
      selectGuests: "Anzahl der Gäste auswählen",
      person: "Person",
      persons: "Personen",
      fullName: "Vollständiger Name *",
      fullNamePlaceholder: "Ihr vollständiger Name",
      emailLabel: "E-Mail *",
      emailPlaceholder: "ihre@email.com",
      message: "Nachricht (optional)",
      messagePlaceholder: "Zusätzliche Anmerkungen oder Fragen...",
      consent: "Ich stimme der Verarbeitung personenbezogener Daten zum Zweck der Anfrage zu *",
      submit: "Anfrage senden",
      sending: "Wird gesendet...",
      successTitle: "Vielen Dank für Ihre Anfrage!",
      successMessage: "Wir werden uns bald bei Ihnen melden.",
      errorTitle: "Fehler beim Senden der Anfrage",
      errorMessage: "Bitte versuchen Sie es erneut oder kontaktieren Sie uns telefonisch.",
    },
    footer: {
      quickLinks: "Schnelllinks",
      contact: "Kontakt",
      rights: "Alle Rechte vorbehalten.",
      privacy: "Datenschutz | Nutzungsbedingungen",
    },
  },

  it: {
    nav: {
      gallery: "Galleria",
      about: "Chi siamo",
      location: "Posizione",
      attractions: "Cosa visitare",
      faq: "FAQ",
      contact: "Contatti",
      sendInquiry: "Invia richiesta",
    },
    hero: {
      welcome: "Benvenuti nel paradiso dell'Adriatico",
      title1: "Appartamenti",
      title2: "Adriatic & Maestral",
      tagline: "Alloggio sulla spiaggia vicino a Orebić con vista mare",
      features: ["Vista mare", "Sulla spiaggia", "WiFi gratuito"],
    },
    gallery: {
      subtitle: "Galleria",
      title: "Guarda i nostri appartamenti",
      enlarge: "Ingrandisci",
    },
    about: {
      subtitle: "Sugli appartamenti",
      title: "Tutto ciò di cui hai bisogno per una vacanza perfetta",
      description: "Gli appartamenti Adriatic e Maestral offrono alloggio sulla spiaggia vicino a Orebić con una splendida vista sul mare. Gli ospiti possono godersi la terrazza soleggiata. Entrambi gli appartamenti dispongono di aria condizionata, bagni privati con articoli da toeletta gratuiti e cucine completamente attrezzate. Ulteriori servizi includono terrazze, WiFi gratuito, smart TV, ecc. Sono disponibili anche parcheggi privati.",
    },
    location: {
      subtitle: "Posizione",
      title: "Dove siamo",
      address: "Indirizzo",
      description: "Gli appartamenti si trovano nel tranquillo villaggio di Borje, vicino a Orebić nella penisola di Pelješac. Bellissime spiagge sono a pochi passi dagli appartamenti, e puoi raggiungere calette nascoste e incantevoli con la tavola SUP (disponibile su richiesta). Sulle bellissime terrazze degli appartamenti puoi goderti il caffè mattutino o la vista serale sul mare, mentre in spiaggia puoi leggere un libro nella piacevole ombra dei pini.\n\nOrebić è a soli 8 minuti di auto, e da lì sono altri 15 minuti in barca per Korčula. Gli amanti della natura possono godersi un'indimenticabile escursione alla vetta più alta di Pelješac, Sv. Ilija, o prendere una barca per il Parco Nazionale di Mljet e il Parco Naturale di Lastovo.\n\nPer chi cerca vacanze attive e adrenalina, nelle vicinanze c'è Viganj - un vero paradiso per i surfisti e uno dei luoghi più famosi per il windsurf e il kitesurf sull'Adriatico. Dubrovnik è a circa 80 minuti di auto.\n\nIdeale per tutti coloro che cercano pace, una bella vista sul mare e sulle isole e un'autentica esperienza dalmata, con la possibilità di avventure sportive nelle vicinanze.",
      openMaps: "Apri in Google Maps",
    },
    attractions: {
      subtitle: "Esplora la zona",
      title: "Cosa visitare?",
      description: "Vicino agli appartamenti ci sono bellissime destinazioni che devi visitare",
      places: {
        orebic: {
          name: "Orebić",
          description: "Una bellissima città dalmata nota per la sua lunga tradizione marittima, bellissime spiagge e vista su Korčula. Passeggia lungo il lungomare, visita il monastero francescano o goditi la gastronomia locale.",
          distance: "8 min in auto",
        },
        viganj: {
          name: "Viganj",
          description: "Paradiso per surfisti e appassionati di sport acquatici! Viganj è noto come una delle migliori destinazioni europee per il windsurf e il kitesurf grazie ai venti ideali del Maestrale.",
          distance: "15 min in auto",
        },
        korcula: {
          name: "Korčula",
          description: "\"Piccola Dubrovnik\" - una città medievale circondata da mura, luogo di nascita di Marco Polo. Esplora le strade strette, le cattedrali e goditi l'atmosfera serale in riva al mare.",
          distance: "15 min in barca da Orebić",
        },
        mljet: {
          name: "Parco Nazionale di Mljet",
          description: "L'isola croata più verde con due laghi salati, un monastero benedettino su un isolotto e natura incontaminata. Ideale per nuotare, andare in kayak e godersi la pace.",
          distance: "1h in barca",
        },
        svIlija: {
          name: "Sv. Ilija - Vetta più alta di Pelješac",
          description: "Un'indimenticabile escursione alla vetta a 961m con vista panoramica su tutta la penisola, le isole e il Mare Adriatico. Il sentiero parte da Orebić attraverso la pineta.",
          distance: "2h di escursione da Orebić",
        },
        dubrovnik: {
          name: "Dubrovnik",
          description: "Perla dell'Adriatico e Patrimonio dell'UNESCO. Passeggia sulle famose mura, esplora lo Stradun, visita la fortezza di Lovrijenac o rinfrescati sulla spiaggia di Banje. Una destinazione imperdibile!",
          distance: "80 min in auto",
        },
      },
    },
    faq: {
      subtitle: "FAQ",
      title: "Domande frequenti",
      items: [
        {
          question: "Quali sono gli orari di check-in e check-out?",
          answer: "Il check-in è dalle 14:00 alle 23:00. Il check-out è dalle 06:00 alle 11:00. Vi preghiamo di comunicarci in anticipo quando pensate di arrivare.",
        },
        {
          question: "Posso portare un animale domestico?",
          answer: "Purtroppo, gli animali domestici non sono ammessi nell'appartamento.",
        },
        {
          question: "L'appartamento ha il parcheggio?",
          answer: "Sì, l'appartamento dispone di un parcheggio gratuito per gli ospiti.",
        },
        {
          question: "È permesso fumare?",
          answer: "Non è permesso fumare all'interno dell'appartamento. Puoi fumare sulla terrazza esterna.",
        },
      ],
    },
    contact: {
      subtitle: "Contatti",
      title: "Contattaci",
      phone: "Telefono",
      email: "Email",
      whatsapp: "Scrivici",
    },
    inquiry: {
      subtitle: "Prenotazione",
      title: "Invia richiesta",
      description: "Compila il modulo e ti risponderemo con un'offerta il prima possibile.",
      checkIn: "Data di arrivo *",
      checkOut: "Data di partenza *",
      selectDate: "Seleziona data",
      guests: "Numero di ospiti *",
      selectGuests: "Seleziona numero di ospiti",
      person: "persona",
      persons: "persone",
      fullName: "Nome completo *",
      fullNamePlaceholder: "Il tuo nome completo",
      emailLabel: "Email *",
      emailPlaceholder: "tua@email.com",
      message: "Messaggio (opzionale)",
      messagePlaceholder: "Note aggiuntive o domande...",
      consent: "Acconsento al trattamento dei dati personali ai fini della richiesta *",
      submit: "Invia richiesta",
      sending: "Invio in corso...",
      successTitle: "Grazie per la tua richiesta!",
      successMessage: "Ti risponderemo presto.",
      errorTitle: "Errore nell'invio della richiesta",
      errorMessage: "Per favore riprova o contattaci telefonicamente.",
    },
    footer: {
      quickLinks: "Link rapidi",
      contact: "Contatti",
      rights: "Tutti i diritti riservati.",
      privacy: "Privacy Policy | Termini di utilizzo",
    },
  },

  fr: {
    nav: {
      gallery: "Galerie",
      about: "À propos",
      location: "Emplacement",
      attractions: "À visiter",
      faq: "FAQ",
      contact: "Contact",
      sendInquiry: "Envoyer une demande",
    },
    hero: {
      welcome: "Bienvenue au paradis de l'Adriatique",
      title1: "Appartements",
      title2: "Adriatic & Maestral",
      tagline: "Hébergement en bord de mer près d'Orebić avec vue sur la mer",
      features: ["Vue mer", "En bord de mer", "WiFi gratuit"],
    },
    gallery: {
      subtitle: "Galerie",
      title: "Découvrez nos appartements",
      enlarge: "Agrandir",
    },
    about: {
      subtitle: "À propos des appartements",
      title: "Tout ce dont vous avez besoin pour des vacances parfaites",
      description: "Les appartements Adriatic et Maestral offrent un hébergement en bord de mer près d'Orebić avec une belle vue sur la mer. Les clients peuvent profiter de la terrasse ensoleillée. Les deux appartements disposent de la climatisation, de salles de bains privées avec articles de toilette gratuits et de cuisines entièrement équipées. Les commodités supplémentaires comprennent des terrasses, le WiFi gratuit, une smart TV, etc. Des places de parking privées sont également disponibles.",
    },
    location: {
      subtitle: "Emplacement",
      title: "Où nous sommes situés",
      address: "Adresse",
      description: "Les appartements sont situés dans le paisible village de Borje, près d'Orebić sur la péninsule de Pelješac. De belles plages sont à quelques pas des appartements, et vous pouvez atteindre des criques cachées et enchanteresses en paddle SUP (disponible sur demande). Sur les belles terrasses des appartements, vous pouvez profiter de votre café du matin ou de la vue sur la mer le soir, tandis que sur la plage vous pouvez lire un livre à l'ombre agréable des pins.\n\nOrebić est à seulement 8 minutes en voiture, et de là c'est encore 15 minutes en bateau jusqu'à Korčula. Les amoureux de la nature peuvent profiter d'une randonnée inoubliable jusqu'au plus haut sommet de Pelješac, Sv. Ilija, ou prendre un bateau vers le parc national de Mljet et le parc naturel de Lastovo.\n\nPour ceux qui recherchent des vacances actives et de l'adrénaline, à proximité se trouve Viganj - un vrai paradis pour les surfeurs et l'un des spots de planche à voile et de kitesurf les plus célèbres de l'Adriatique. Dubrovnik est à environ 80 minutes en voiture.\n\nIdéal pour tous ceux qui recherchent la paix, une belle vue sur la mer et les îles et une expérience dalmate authentique, avec la possibilité d'aventures sportives à proximité.",
      openMaps: "Ouvrir dans Google Maps",
    },
    attractions: {
      subtitle: "Explorez les environs",
      title: "Que visiter?",
      description: "Près des appartements se trouvent de belles destinations que vous devez visiter",
      places: {
        orebic: {
          name: "Orebić",
          description: "Une belle ville dalmate connue pour sa longue tradition maritime, ses belles plages et sa vue sur Korčula. Promenez-vous le long du front de mer, visitez le monastère franciscain ou profitez de la gastronomie locale.",
          distance: "8 min en voiture",
        },
        viganj: {
          name: "Viganj",
          description: "Paradis pour les surfeurs et les amateurs de sports nautiques! Viganj est connu comme l'une des meilleures destinations européennes pour la planche à voile et le kitesurf grâce aux vents idéaux du Mistral.",
          distance: "15 min en voiture",
        },
        korcula: {
          name: "Korčula",
          description: "\"Petite Dubrovnik\" - une ville médiévale entourée de murailles, lieu de naissance de Marco Polo. Explorez les rues étroites, les cathédrales et profitez de l'atmosphère du soir au bord de la mer.",
          distance: "15 min en bateau depuis Orebić",
        },
        mljet: {
          name: "Parc national de Mljet",
          description: "L'île croate la plus verte avec deux lacs salés, un monastère bénédictin sur un îlot et une nature intacte. Idéal pour la baignade, le kayak et profiter de la paix.",
          distance: "1h en bateau",
        },
        svIlija: {
          name: "Sv. Ilija - Plus haut sommet de Pelješac",
          description: "Une randonnée inoubliable jusqu'au sommet à 961m avec une vue panoramique sur toute la péninsule, les îles et la mer Adriatique. Le sentier part d'Orebić à travers la forêt de pins.",
          distance: "2h de randonnée depuis Orebić",
        },
        dubrovnik: {
          name: "Dubrovnik",
          description: "Perle de l'Adriatique et site du patrimoine mondial de l'UNESCO. Promenez-vous sur les célèbres remparts, explorez le Stradun, visitez la forteresse de Lovrijenac ou rafraîchissez-vous sur la plage de Banje. Une destination incontournable!",
          distance: "80 min en voiture",
        },
      },
    },
    faq: {
      subtitle: "FAQ",
      title: "Questions fréquentes",
      items: [
        {
          question: "Quels sont les horaires d'arrivée et de départ?",
          answer: "L'arrivée est de 14h00 à 23h00. Le départ est de 06h00 à 11h00. Veuillez nous informer à l'avance de votre heure d'arrivée prévue.",
        },
        {
          question: "Puis-je amener un animal de compagnie?",
          answer: "Malheureusement, les animaux de compagnie ne sont pas autorisés dans l'appartement.",
        },
        {
          question: "L'appartement dispose-t-il d'un parking?",
          answer: "Oui, l'appartement dispose d'un parking gratuit pour les clients.",
        },
        {
          question: "Est-il permis de fumer?",
          answer: "Il est interdit de fumer à l'intérieur de l'appartement. Vous pouvez fumer sur la terrasse extérieure.",
        },
      ],
    },
    contact: {
      subtitle: "Contact",
      title: "Contactez-nous",
      phone: "Téléphone",
      email: "Email",
      whatsapp: "Écrivez-nous",
    },
    inquiry: {
      subtitle: "Réservation",
      title: "Envoyer une demande",
      description: "Remplissez le formulaire et nous vous répondrons avec une offre dans les plus brefs délais.",
      checkIn: "Date d'arrivée *",
      checkOut: "Date de départ *",
      selectDate: "Sélectionner la date",
      guests: "Nombre de personnes *",
      selectGuests: "Sélectionner le nombre de personnes",
      person: "personne",
      persons: "personnes",
      fullName: "Nom complet *",
      fullNamePlaceholder: "Votre nom complet",
      emailLabel: "Email *",
      emailPlaceholder: "votre@email.com",
      message: "Message (optionnel)",
      messagePlaceholder: "Notes supplémentaires ou questions...",
      consent: "J'accepte le traitement de mes données personnelles aux fins de la demande *",
      submit: "Envoyer la demande",
      sending: "Envoi en cours...",
      successTitle: "Merci pour votre demande!",
      successMessage: "Nous vous répondrons bientôt.",
      errorTitle: "Erreur lors de l'envoi de la demande",
      errorMessage: "Veuillez réessayer ou nous contacter par téléphone.",
    },
    footer: {
      quickLinks: "Liens rapides",
      contact: "Contact",
      rights: "Tous droits réservés.",
      privacy: "Politique de confidentialité | Conditions d'utilisation",
    },
  },

  pl: {
    nav: {
      gallery: "Galeria",
      about: "O nas",
      location: "Lokalizacja",
      attractions: "Co zwiedzić",
      faq: "FAQ",
      contact: "Kontakt",
      sendInquiry: "Wyślij zapytanie",
    },
    hero: {
      welcome: "Witamy w raju nad Adriatykiem",
      title1: "Apartamenty",
      title2: "Adriatic & Maestral",
      tagline: "Zakwaterowanie przy plaży w pobliżu Orebicia z widokiem na morze",
      features: ["Widok na morze", "Przy plaży", "Bezpłatne WiFi"],
    },
    gallery: {
      subtitle: "Galeria",
      title: "Zobacz nasze apartamenty",
      enlarge: "Powiększ",
    },
    about: {
      subtitle: "O apartamentach",
      title: "Wszystko, czego potrzebujesz na idealne wakacje",
      description: "Apartamenty Adriatic i Maestral oferują zakwaterowanie przy plaży w pobliżu Orebicia z pięknym widokiem na morze. Goście mogą korzystać ze słonecznego tarasu. Oba apartamenty mają klimatyzację, prywatne łazienki z bezpłatnymi przyborami toaletowymi i w pełni wyposażone kuchnie. Dodatkowe udogodnienia obejmują tarasy, bezpłatne WiFi, smart TV itp. Dostępne są również prywatne miejsca parkingowe.",
    },
    location: {
      subtitle: "Lokalizacja",
      title: "Gdzie się znajdujemy",
      address: "Adres",
      description: "Apartamenty znajdują się w spokojnej wiosce Borje, w pobliżu Orebicia na półwyspie Pelješac. Piękne plaże są tuż obok apartamentów, a ukryte, urokliwe zatoczki można dotrzeć deską SUP (dostępna na życzenie). Na pięknych tarasach apartamentów można cieszyć się poranną kawą lub wieczornym widokiem na morze, podczas gdy na plaży można czytać książkę w przyjemnym cieniu sosen.\n\nOrebić jest zaledwie 8 minut jazdy samochodem, a stamtąd kolejne 15 minut łodzią do Korčuli. Miłośnicy przyrody mogą cieszyć się niezapomnianą wędrówką na najwyższy szczyt Pelješac, Sv. Ilija, lub popłynąć łodzią do Parku Narodowego Mljet i Parku Przyrody Lastovo.\n\nDla tych, którzy szukają aktywnego wypoczynku i adrenaliny, w pobliżu znajduje się Viganj — prawdziwy raj dla surferów i jedno z najsłynniejszych miejsc do windsurfingu i kitesurfingu na Adriatyku. Dubrownik jest oddalony o około 80 minut jazdy samochodem.\n\nIdealne dla wszystkich, którzy szukają spokoju, pięknego widoku na morze i wyspy oraz autentycznego dalmackiego przeżycia, z możliwością sportowych przygód w pobliżu.",
      openMaps: "Otwórz w Google Maps",
    },
    attractions: {
      subtitle: "Odkryj okolicę",
      title: "Co zwiedzić?",
      description: "W pobliżu apartamentów znajdują się piękne miejsca, które musisz odwiedzić",
      places: {
        orebic: {
          name: "Orebić",
          description: "Piękne dalmatyńskie miasteczko znane z długiej tradycji morskiej, pięknych plaż i widoku na Korčulę. Spaceruj wzdłuż nabrzeża, odwiedź klasztor franciszkański lub ciesz się lokalną gastronomią.",
          distance: "8 min jazdy",
        },
        viganj: {
          name: "Viganj",
          description: "Raj dla surferów i miłośników sportów wodnych! Viganj jest znany jako jedno z najlepszych europejskich miejsc do windsurfingu i kitesurfingu dzięki idealnym wiatrom Maestral.",
          distance: "15 min jazdy",
        },
        korcula: {
          name: "Korčula",
          description: "\"Mały Dubrownik\" - średniowieczne miasto otoczone murami, miejsce urodzenia Marco Polo. Odkryj wąskie uliczki, katedry i ciesz się wieczorną atmosferą nad morzem.",
          distance: "15 min łodzią z Orebicia",
        },
        mljet: {
          name: "Park Narodowy Mljet",
          description: "Najzieleńsza chorwacka wyspa z dwoma słonymi jeziorami, klasztorem benedyktyńskim na wysepce i nieskażoną przyrodą. Idealne do pływania, kajakarstwa i cieszenia się ciszą.",
          distance: "1h łodzią",
        },
        svIlija: {
          name: "Sv. Ilija - Najwyższy szczyt Pelješac",
          description: "Niezapomniana wędrówka na szczyt na wysokości 961m z panoramicznym widokiem na cały półwysep, wyspy i Morze Adriatyckie. Szlak zaczyna się w Orebiciú przez las sosnowy.",
          distance: "2h wędrówki z Orebicia",
        },
        dubrovnik: {
          name: "Dubrownik",
          description: "Perła Adriatyku i obiekt UNESCO. Spaceruj słynnymi murami, odkrywaj Stradun, odwiedź twierdzę Lovrijenac lub ochłodź się na plaży Banje. Miejsce obowiązkowe!",
          distance: "80 min jazdy",
        },
      },
    },
    faq: {
      subtitle: "FAQ",
      title: "Często zadawane pytania",
      items: [
        {
          question: "Jakie są godziny zameldowania i wymeldowania?",
          answer: "Zameldowanie od 14:00 do 23:00. Wymeldowanie od 06:00 do 11:00. Prosimy o wcześniejsze poinformowanie nas o planowanej godzinie przyjazdu.",
        },
        {
          question: "Czy mogę przyjechać ze zwierzęciem?",
          answer: "Niestety, zwierzęta domowe nie są dozwolone w apartamencie.",
        },
        {
          question: "Czy apartament ma parking?",
          answer: "Tak, apartament ma bezpłatne miejsce parkingowe dla gości.",
        },
        {
          question: "Czy wolno palić?",
          answer: "Palenie jest zabronione w apartamencie. Można palić na zewnętrznym tarasie.",
        },
      ],
    },
    contact: {
      subtitle: "Kontakt",
      title: "Skontaktuj się z nami",
      phone: "Telefon",
      email: "Email",
      whatsapp: "Napisz do nas",
    },
    inquiry: {
      subtitle: "Rezerwacja",
      title: "Wyślij zapytanie",
      description: "Wypełnij formularz, a my skontaktujemy się z Tobą z ofertą najszybciej jak to możliwe.",
      checkIn: "Data przyjazdu *",
      checkOut: "Data wyjazdu *",
      selectDate: "Wybierz datę",
      guests: "Liczba gości *",
      selectGuests: "Wybierz liczbę gości",
      person: "osoba",
      persons: "osoby",
      fullName: "Imię i nazwisko *",
      fullNamePlaceholder: "Twoje imię i nazwisko",
      emailLabel: "Email *",
      emailPlaceholder: "twoj@email.com",
      message: "Wiadomość (opcjonalnie)",
      messagePlaceholder: "Dodatkowe uwagi lub pytania...",
      consent: "Wyrażam zgodę na przetwarzanie danych osobowych w celu realizacji zapytania *",
      submit: "Wyślij zapytanie",
      sending: "Wysyłanie...",
      successTitle: "Dziękujemy za zapytanie!",
      successMessage: "Skontaktujemy się z Tobą wkrótce.",
      errorTitle: "Błąd podczas wysyłania zapytania",
      errorMessage: "Spróbuj ponownie lub skontaktuj się z nami telefonicznie.",
    },
    footer: {
      quickLinks: "Szybkie linki",
      contact: "Kontakt",
      rights: "Wszelkie prawa zastrzeżone.",
      privacy: "Polityka prywatności | Regulamin",
    },
  },

  cs: {
    nav: {
      gallery: "Galerie",
      about: "O nás",
      location: "Poloha",
      attractions: "Co navštívit",
      faq: "FAQ",
      contact: "Kontakt",
      sendInquiry: "Odeslat poptávku",
    },
    hero: {
      welcome: "Vítejte v ráji na Jadranu",
      title1: "Apartmány",
      title2: "Adriatic & Maestral",
      tagline: "Ubytování u pláže poblíž Orebiće s výhledem na moře",
      features: ["Výhled na moře", "U pláže", "Bezplatné WiFi"],
    },
    gallery: {
      subtitle: "Galerie",
      title: "Prohlédněte si naše apartmány",
      enlarge: "Zvětšit",
    },
    about: {
      subtitle: "O apartmánech",
      title: "Vše, co potřebujete pro dokonalou dovolenou",
      description: "Apartmány Adriatic a Maestral nabízejí ubytování u pláže poblíž Orebiće s krásným výhledem na moře. Hosté si mohou užívat slunnou terasu. Oba apartmány mají klimatizaci, vlastní koupelny s bezplatnými toaletními potřebami a plně vybavené kuchyně. Další vybavení zahrnuje terasy, bezplatné WiFi, chytrou TV atd. K dispozici jsou také soukromá parkovací místa.",
    },
    location: {
      subtitle: "Poloha",
      title: "Kde se nacházíme",
      address: "Adresa",
      description: "Apartmány se nacházejí v klidné vesnici Borje, poblíž Orebiće na poloostrově Pelješac. Krásné pláže jsou na dosah apartmánů a skryté, okouzlující zátoky můžete dosáhnout na SUP prkně (k dispozici na vyžádání). Na krásných terasách apartmánů si můžete vychutnat ranní kávu nebo večerní výhled na moře, zatímco na pláži si můžete číst knihu v příjemném stínu borovic.\n\nOrebić je jen 8 minut jízdy autem a odtud dalších 15 minut lodí do Korčuly. Milovníci přírody si mohou užít nezapomenutelnou túru na nejvyšší vrchol Pelješace, Sv. Ilija, nebo se vydat lodí do Národního parku Mljet a Přírodního parku Lastovo.\n\nPro ty, kteří hledají aktivní dovolenou a adrenalin, je poblíž Viganj — skutečný ráj pro surfaře a jedno z nejznámějších míst pro windsurfing a kitesurfing na Jadranu. Dubrovník je vzdálen asi 80 minut jízdy autem.\n\nIdeální pro všechny, kteří hledají klid, krásný výhled na moře a ostrovy a autentický dalmatský zážitek, s možností sportovních dobrodružství v blízkosti.",
      openMaps: "Otevřít v Google Maps",
    },
    attractions: {
      subtitle: "Prozkoumejte okolí",
      title: "Co navštívit?",
      description: "Poblíž apartmánů se nacházejí krásné destinace, které musíte navštívit",
      places: {
        orebic: {
          name: "Orebić",
          description: "Krásné dalmatské městečko známé svou dlouhou námořní tradicí, krásnými plážemi a výhledem na Korčulu. Projděte se po nábřeží, navštivte františkánský klášter nebo si vychutnejte místní gastronomii.",
          distance: "8 min jízdy",
        },
        viganj: {
          name: "Viganj",
          description: "Ráj pro surfaře a milovníky vodních sportů! Viganj je známý jako jedna z nejlepších evropských destinací pro windsurfing a kitesurfing díky ideálním větrům Maestral.",
          distance: "15 min jízdy",
        },
        korcula: {
          name: "Korčula",
          description: "\"Malý Dubrovník\" - středověké město obklopené hradbami, rodiště Marca Pola. Prozkoumejte úzké uličky, katedrály a užijte si večerní atmosféru u moře.",
          distance: "15 min lodí z Orebiće",
        },
        mljet: {
          name: "Národní park Mljet",
          description: "Nejzelenější chorvatský ostrov se dvěma slanými jezery, benediktinským klášterem na ostrůvku a nedotčenou přírodou. Ideální pro plavání, jízdu na kajaku a užívání si klidu.",
          distance: "1h lodí",
        },
        svIlija: {
          name: "Sv. Ilija - Nejvyšší vrchol Pelješace",
          description: "Nezapomenutelná túra na vrchol ve výšce 961m s panoramatickým výhledem na celý poloostrov, ostrovy a Jadranské moře. Stezka začíná v Orebiči borovým lesem.",
          distance: "2h túry z Orebiće",
        },
        dubrovnik: {
          name: "Dubrovník",
          description: "Perla Jadranu a památka UNESCO. Projděte se po slavných hradbách, prozkoumejte Stradun, navštivte pevnost Lovrijenac nebo se osvěžte na pláži Banje. Destinace, kterou musíte vidět!",
          distance: "80 min jízdy",
        },
      },
    },
    faq: {
      subtitle: "FAQ",
      title: "Často kladené dotazy",
      items: [
        {
          question: "Jaké jsou časy příjezdu a odjezdu?",
          answer: "Check-in je od 14:00 do 23:00. Check-out je od 06:00 do 11:00. Prosíme, informujte nás předem o plánovaném čase příjezdu.",
        },
        {
          question: "Mohu přijet se zvířetem?",
          answer: "Bohužel, domácí mazlíčci nejsou v apartmánu povoleni.",
        },
        {
          question: "Má apartmán parkování?",
          answer: "Ano, apartmán má bezplatné parkovací místo pro hosty.",
        },
        {
          question: "Je povoleno kouření?",
          answer: "Kouření není v apartmánu povoleno. Můžete kouřit na venkovní terase.",
        },
      ],
    },
    contact: {
      subtitle: "Kontakt",
      title: "Kontaktujte nás",
      phone: "Telefon",
      email: "Email",
      whatsapp: "Napište nám",
    },
    inquiry: {
      subtitle: "Rezervace",
      title: "Odeslat poptávku",
      description: "Vyplňte formulář a my se vám ozveme s nabídkou co nejdříve.",
      checkIn: "Datum příjezdu *",
      checkOut: "Datum odjezdu *",
      selectDate: "Vyberte datum",
      guests: "Počet hostů *",
      selectGuests: "Vyberte počet hostů",
      person: "osoba",
      persons: "osoby",
      fullName: "Celé jméno *",
      fullNamePlaceholder: "Vaše celé jméno",
      emailLabel: "Email *",
      emailPlaceholder: "vas@email.com",
      message: "Zpráva (volitelně)",
      messagePlaceholder: "Další poznámky nebo dotazy...",
      consent: "Souhlasím se zpracováním osobních údajů za účelem zpracování poptávky *",
      submit: "Odeslat poptávku",
      sending: "Odesílání...",
      successTitle: "Děkujeme za vaši poptávku!",
      successMessage: "Brzy se vám ozveme.",
      errorTitle: "Chyba při odesílání poptávky",
      errorMessage: "Zkuste to prosím znovu nebo nás kontaktujte telefonicky.",
    },
    footer: {
      quickLinks: "Rychlé odkazy",
      contact: "Kontakt",
      rights: "Všechna práva vyhrazena.",
      privacy: "Zásady ochrany osobních údajů | Podmínky použití",
    },
  },

  hu: {
    nav: {
      gallery: "Galéria",
      about: "Rólunk",
      location: "Helyszín",
      attractions: "Látnivalók",
      faq: "GYIK",
      contact: "Kapcsolat",
      sendInquiry: "Érdeklődés küldése",
    },
    hero: {
      welcome: "Üdvözöljük az Adria paradicsomában",
      title1: "Apartmanok",
      title2: "Adriatic & Maestral",
      tagline: "Tengerparti szállás Orebić közelében kilátással a tengerre",
      features: ["Tengerre néző", "Tengerparton", "Ingyenes WiFi"],
    },
    gallery: {
      subtitle: "Galéria",
      title: "Nézze meg apartmanjainkat",
      enlarge: "Nagyítás",
    },
    about: {
      subtitle: "Az apartmanokról",
      title: "Minden, amire szüksége van a tökéletes nyaraláshoz",
      description: "Az Adriatic és Maestral apartmanok tengerparti szállást kínálnak Orebić közelében, gyönyörű kilátással a tengerre. A vendégek élvezhetik a napos teraszt. Mindkét apartman légkondicionált, privát fürdőszobával rendelkezik ingyenes piperecikkekkel és teljesen felszerelt konyhával. További szolgáltatások közé tartoznak a teraszok, ingyenes WiFi, okos TV stb. Privát parkolóhelyek is rendelkezésre állnak.",
    },
    location: {
      subtitle: "Helyszín",
      title: "Hol találhatók",
      address: "Cím",
      description: "Az apartmanok a csendes Borje faluban találhatók, Orebić közelében a Pelješac-félszigeten. Gyönyörű strandok vannak az apartmanok közelében, és SUP deszkával elérheti a rejtett, elbűvölő öblöket (kérésre elérhető). Az apartmanok gyönyörű teraszain élvezheti reggeli kávéját vagy az esti tengeri kilátást, míg a strandon könyvet olvashat a fenyők kellemes árnyékában.\n\nOrebić mindössze 8 percre van autóval, onnan pedig további 15 perc hajóval Korčulára. A természetkedvelők felejthetetlen túrát tehetnek a Pelješac legmagasabb csúcsára, a Sv. Ilijára, vagy hajóval a Mljet Nemzeti Parkba és a Lastovo Természeti Parkba.\n\nAzok számára, akik aktív pihenést és adrenalint keresnek, a közelben van Viganj – igazi paradicsom a szörfösöknek és az Adria egyik leghíresebb szörf- és kiteszörf helyszíne. Dubrovnik körülbelül 80 perc autóútra van.\n\nIdeális mindazok számára, akik nyugalmat, gyönyörű kilátást a tengerre és a szigetekre, valamint autentikus dalmát élményt keresnek, a közelben sportkalandok lehetőségével.",
      openMaps: "Megnyitás Google Maps-ben",
    },
    attractions: {
      subtitle: "Fedezze fel a környéket",
      title: "Mit érdemes meglátogatni?",
      description: "Az apartmanok közelében gyönyörű úti célok találhatók, amelyeket meg kell látogatnia",
      places: {
        orebic: {
          name: "Orebić",
          description: "Gyönyörű dalmát kisváros, amely hosszú tengeri hagyományáról, gyönyörű strandjairól és Korčulára néző kilátásáról ismert. Sétáljon a vízparton, látogassa meg a ferences kolostort vagy élvezze a helyi gasztronómiát.",
          distance: "8 perc autóval",
        },
        viganj: {
          name: "Viganj",
          description: "Paradicsom szörfösöknek és vízi sportok kedvelőinek! Viganj az ideális Maestral szeleknek köszönhetően Európa egyik legjobb szörf- és kiteszörf úti céljaként ismert.",
          distance: "15 perc autóval",
        },
        korcula: {
          name: "Korčula",
          description: "\"Kis Dubrovnik\" - falakkal körülvett középkori város, Marco Polo szülőhelye. Fedezze fel a szűk utcákat, a katedrálisokat és élvezze az esti hangulatot a tenger mellett.",
          distance: "15 perc hajóval Orebićből",
        },
        mljet: {
          name: "Mljet Nemzeti Park",
          description: "A legzöldebb horvát sziget két sós tóval, bencés kolostorral egy kis szigeten és érintetlen természettel. Ideális úszásra, kajakozásra és a nyugalom élvezetére.",
          distance: "1 óra hajóval",
        },
        svIlija: {
          name: "Sv. Ilija - Pelješac legmagasabb csúcsa",
          description: "Felejthetetlen túra a 961 m-es csúcsra, panorámás kilátással az egész félszigetre, a szigetekre és az Adriai-tengerre. Az ösvény Orebićből indul a fenyőerdőn keresztül.",
          distance: "2 óra túra Orebićből",
        },
        dubrovnik: {
          name: "Dubrovnik",
          description: "Az Adria gyöngye és UNESCO világörökségi helyszín. Sétáljon a híres falakon, fedezze fel a Stradunt, látogassa meg a Lovrijenac erődöt vagy frissüljön fel a Banje strandon. Kötelező úti cél!",
          distance: "80 perc autóval",
        },
      },
    },
    faq: {
      subtitle: "GYIK",
      title: "Gyakran ismételt kérdések",
      items: [
        {
          question: "Mikor van a bejelentkezés és kijelentkezés?",
          answer: "A bejelentkezés 14:00-tól 23:00-ig tart. A kijelentkezés 06:00-tól 11:00-ig van. Kérjük, előre jelezze, mikor tervez érkezni.",
        },
        {
          question: "Hozhatok háziállatot?",
          answer: "Sajnos háziállatok nem engedélyezettek az apartmanban.",
        },
        {
          question: "Van az apartmannak parkolója?",
          answer: "Igen, az apartman ingyenes parkolóhellyel rendelkezik a vendégek számára.",
        },
        {
          question: "Szabad dohányozni?",
          answer: "A dohányzás az apartmanban nem megengedett. A kültéri teraszon dohányozhat.",
        },
      ],
    },
    contact: {
      subtitle: "Kapcsolat",
      title: "Lépjen kapcsolatba velünk",
      phone: "Telefon",
      email: "Email",
      whatsapp: "Írjon nekünk",
    },
    inquiry: {
      subtitle: "Foglalás",
      title: "Érdeklődés küldése",
      description: "Töltse ki az űrlapot, és mielőbb jelentkezünk ajánlatunkkal.",
      checkIn: "Érkezés dátuma *",
      checkOut: "Távozás dátuma *",
      selectDate: "Válasszon dátumot",
      guests: "Vendégek száma *",
      selectGuests: "Válassza ki a vendégek számát",
      person: "fő",
      persons: "fő",
      fullName: "Teljes név *",
      fullNamePlaceholder: "Az Ön teljes neve",
      emailLabel: "Email *",
      emailPlaceholder: "az.on@email.com",
      message: "Üzenet (opcionális)",
      messagePlaceholder: "További megjegyzések vagy kérdések...",
      consent: "Hozzájárulok személyes adataim feldolgozásához az érdeklődés céljából *",
      submit: "Érdeklődés küldése",
      sending: "Küldés...",
      successTitle: "Köszönjük érdeklődését!",
      successMessage: "Hamarosan jelentkezünk.",
      errorTitle: "Hiba az érdeklődés küldésekor",
      errorMessage: "Kérjük, próbálja újra, vagy hívjon minket telefonon.",
    },
    footer: {
      quickLinks: "Gyors linkek",
      contact: "Kapcsolat",
      rights: "Minden jog fenntartva.",
      privacy: "Adatvédelmi irányelvek | Felhasználási feltételek",
    },
  },

  sl: {
    nav: {
      gallery: "Galerija",
      about: "O nas",
      location: "Lokacija",
      attractions: "Kaj obiskati",
      faq: "Pogosta vprašanja",
      contact: "Kontakt",
      sendInquiry: "Pošlji povpraševanje",
    },
    hero: {
      welcome: "Dobrodošli v raju na Jadranu",
      title1: "Apartmaji",
      title2: "Adriatic & Maestral",
      tagline: "Nastanitev ob plaži v bližini Orebića z razgledom na morje",
      features: ["Razgled na morje", "Ob plaži", "Brezplačen WiFi"],
    },
    gallery: {
      subtitle: "Galerija",
      title: "Oglejte si naše apartmaje",
      enlarge: "Povečaj",
    },
    about: {
      subtitle: "O apartmajih",
      title: "Vse, kar potrebujete za popoln dopust",
      description: "Apartmaja Adriatic in Maestral ponujata nastanitev ob plaži v bližini Orebića s čudovitim razgledom na morje. Gostje lahko uživajo na sončni terasi. Oba apartmaja imata klimatsko napravo, zasebne kopalnice z brezplačnimi toaletnimi potrebščinami in popolnoma opremljene kuhinje. Dodatne ugodnosti vključujejo terase, brezplačen WiFi, pametni TV itd. Na voljo so tudi zasebna parkirna mesta.",
    },
    location: {
      subtitle: "Lokacija",
      title: "Kje se nahajamo",
      address: "Naslov",
      description: "Apartmaji se nahajajo v mirni vasici Borje, v bližini Orebića na polotoku Pelješac. Čudovite plaže so tik ob apartmajih, skrite, očarljive zalive pa lahko dosežete s SUP desko (na voljo na zahtevo). Na čudovitih terasah apartmajev lahko uživate v jutranji kavi ali večernem razgledu na morje, medtem ko lahko na plaži berete knjigo v prijetni senci borov.\n\nOrebić je le 8 minut vožnje z avtom, od tam pa še 15 minut z ladjo do Korčule. Ljubitelji narave lahko uživajo v nepozabnem pohodu na najvišji vrh Pelješca, Sv. Ilijo, ali se z ladjo odpravijo v Narodni park Mljet in Park narave Lastovo.\n\nZa tiste, ki iščejo aktiven dopust in adrenalin, je v bližini Viganj - pravi raj za deskarje in eno najslavnejših mest za deskanje na vodi in kitesurfanje na Jadranu. Dubrovnik je oddaljen približno 80 minut vožnje z avtom.\n\nIdealno za vse, ki iščejo mir, čudovit razgled na morje in otoke ter pristno dalmatinsko izkušnjo, z možnostjo športnih pustolovščin v bližini.",
      openMaps: "Odpri v Google Maps",
    },
    attractions: {
      subtitle: "Raziščite okolico",
      title: "Kaj obiskati?",
      description: "V bližini apartmajev so čudovite destinacije, ki jih morate obiskati",
      places: {
        orebic: {
          name: "Orebić",
          description: "Čudovito dalmatinsko mestece, znano po dolgi pomorski tradiciji, čudovitih plažah in razgledu na Korčulo. Sprehodite se po obali, obiščite frančiškanski samostan ali uživajte v lokalni gastronomiji.",
          distance: "8 min vožnje",
        },
        viganj: {
          name: "Viganj",
          description: "Raj za deskarje in ljubitelje vodnih športov! Viganj je znan kot ena najboljših evropskih destinacij za deskanje na vodi in kitesurfanje zahvaljujoč idealnim vetrovom Maestral.",
          distance: "15 min vožnje",
        },
        korcula: {
          name: "Korčula",
          description: "\"Mali Dubrovnik\" - srednjeveško mesto, obdano z obzidjem, rojstni kraj Marca Pola. Raziščite ozke uličice, katedrale in uživajte v večerni atmosferi ob morju.",
          distance: "15 min z ladjo iz Orebića",
        },
        mljet: {
          name: "Narodni park Mljet",
          description: "Najzelenjši hrvaški otok z dvema slanima jezeroma, benediktinskim samostanom na otočku in nedotaknjeno naravo. Idealno za plavanje, kajakaštvo in uživanje v miru.",
          distance: "1h z ladjo",
        },
        svIlija: {
          name: "Sv. Ilija - Najvišji vrh Pelješca",
          description: "Nepozaben pohod na vrh na 961m s panoramskim razgledom na celoten polotok, otoke in Jadransko morje. Pot se začne v Orebiću skozi borov gozd.",
          distance: "2h pohoda iz Orebića",
        },
        dubrovnik: {
          name: "Dubrovnik",
          description: "Biser Jadrana in UNESCO-va svetovna dediščina. Sprehodite se po slavnih obzidjih, raziščite Stradun, obiščite trdnjavo Lovrijenac ali se osvežite na plaži Banje. Destinacija, ki jo morate obiskati!",
          distance: "80 min vožnje",
        },
      },
    },
    faq: {
      subtitle: "Pogosta vprašanja",
      title: "Pogosto zastavljena vprašanja",
      items: [
        {
          question: "Kdaj je čas prihoda in odhoda?",
          answer: "Prijava je od 14:00 do 23:00. Odjava je od 06:00 do 11:00. Prosimo, da nas vnaprej obvestite o načrtovanem času prihoda.",
        },
        {
          question: "Ali lahko pripeljem hišnega ljubljenčka?",
          answer: "Na žalost hišni ljubljenčki v apartmaju niso dovoljeni.",
        },
        {
          question: "Ali ima apartma parkirišče?",
          answer: "Da, apartma ima brezplačno parkirno mesto za goste.",
        },
        {
          question: "Ali je kajenje dovoljeno?",
          answer: "Kajenje v apartmaju ni dovoljeno. Kadite lahko na zunanji terasi.",
        },
      ],
    },
    contact: {
      subtitle: "Kontakt",
      title: "Stopite v stik z nami",
      phone: "Telefon",
      email: "E-pošta",
      whatsapp: "Pišite nam",
    },
    inquiry: {
      subtitle: "Rezervacija",
      title: "Pošlji povpraševanje",
      description: "Izpolnite obrazec in javili se vam bomo s ponudbo v najkrajšem možnem času.",
      checkIn: "Datum prihoda *",
      checkOut: "Datum odhoda *",
      selectDate: "Izberite datum",
      guests: "Število gostov *",
      selectGuests: "Izberite število gostov",
      person: "oseba",
      persons: "osebe",
      fullName: "Ime in priimek *",
      fullNamePlaceholder: "Vaše ime in priimek",
      emailLabel: "E-pošta *",
      emailPlaceholder: "vas@email.com",
      message: "Sporočilo (izbirno)",
      messagePlaceholder: "Dodatne opombe ali vprašanja...",
      consent: "Strinjam se z obdelavo osebnih podatkov za namene povpraševanja *",
      submit: "Pošlji povpraševanje",
      sending: "Pošiljanje...",
      successTitle: "Hvala za vaše povpraševanje!",
      successMessage: "Kmalu se vam bomo oglasili.",
      errorTitle: "Napaka pri pošiljanju povpraševanja",
      errorMessage: "Prosimo, poskusite znova ali nas kontaktirajte po telefonu.",
    },
    footer: {
      quickLinks: "Hitre povezave",
      contact: "Kontakt",
      rights: "Vse pravice pridržane.",
      privacy: "Politika zasebnosti | Pogoji uporabe",
    },
  },

  sk: {
    nav: {
      gallery: "Galéria",
      about: "O nás",
      location: "Poloha",
      attractions: "Čo navštíviť",
      faq: "FAQ",
      contact: "Kontakt",
      sendInquiry: "Odoslať dopyt",
    },
    hero: {
      welcome: "Vitajte v raji na Jadrane",
      title1: "Apartmány",
      title2: "Adriatic & Maestral",
      tagline: "Ubytovanie pri pláži neďaleko Orebiča s výhľadom na more",
      features: ["Výhľad na more", "Pri pláži", "Bezplatné WiFi"],
    },
    gallery: {
      subtitle: "Galéria",
      title: "Prezrite si naše apartmány",
      enlarge: "Zväčšiť",
    },
    about: {
      subtitle: "O apartmánoch",
      title: "Všetko, čo potrebujete pre dokonalú dovolenku",
      description: "Apartmány Adriatic a Maestral ponúkajú ubytovanie pri pláži neďaleko Orebiča s krásnym výhľadom na more. Hostia si môžu vychutnať slnečnú terasu. Oba apartmány majú klimatizáciu, vlastné kúpeľne s bezplatnými toaletnými potrebami a plne vybavenú kuchyňu. Medzi ďalšie vybavenie patria terasy, bezplatné WiFi, smart TV atď. K dispozícii sú aj súkromné parkovacie miesta.",
    },
    location: {
      subtitle: "Poloha",
      title: "Kde sa nachádzame",
      address: "Adresa",
      description: "Apartmány sa nachádzajú v pokojnej dedine Borje, neďaleko Orebiča na polostrove Pelješac. Krásne pláže sú na dosah apartmánov a skryté, očarujúce zátoky môžete dosiahnuť na SUP doske (k dispozícii na požiadanie). Na krásnych terasách apartmánov si môžete vychutnať rannú kávu alebo večerný výhľad na more, zatiaľ čo na pláži si môžete prečítať knihu v príjemnom tieni borovíc.\n\nOrebič je len 8 minút jazdy autom a odtiaľ ďalších 15 minút loďou do Korčuly. Milovníci prírody si môžu užiť nezabudnuteľnú túru na najvyšší vrch Pelješaca, Sv. Iliju, alebo sa vydať loďou do Národného parku Mljet a Prírodného parku Lastovo.\n\nPre tých, ktorí hľadajú aktívnu dovolenku a adrenalín, je v blízkosti Viganj - skutočný raj pre surfistov a jedno z najslávnejších miest pre windsurfing a kitesurfing na Jadrane. Dubrovník je vzdialený asi 80 minút jazdy autom.\n\nIdeálne pre všetkých, ktorí hľadajú pokoj, krásny výhľad na more a ostrovy a autentický dalmatínsky zážitok, s možnosťou športových dobrodružstiev v blízkosti.",
      openMaps: "Otvoriť v Google Maps",
    },
    attractions: {
      subtitle: "Preskúmajte okolie",
      title: "Čo navštíviť?",
      description: "V blízkosti apartmánov sa nachádzajú krásne destinácie, ktoré musíte navštíviť",
      places: {
        orebic: {
          name: "Orebič",
          description: "Krásne dalmatínske mestečko známe svojou dlhou námornou tradíciou, krásnymi plážami a výhľadom na Korčulu. Prejdite sa po nábreží, navštívte františkánsky kláštor alebo si vychutnajte miestnu gastronómiu.",
          distance: "8 min jazdy",
        },
        viganj: {
          name: "Viganj",
          description: "Raj pre surfistov a milovníkov vodných športov! Viganj je známy ako jedna z najlepších európskych destinácií pre windsurfing a kitesurfing vďaka ideálnym vetrom Maestral.",
          distance: "15 min jazdy",
        },
        korcula: {
          name: "Korčula",
          description: "\"Malý Dubrovník\" - stredoveké mesto obklopené hradbami, rodisko Marca Pola. Preskúmajte úzke uličky, katedrály a užite si večernú atmosféru pri mori.",
          distance: "15 min loďou z Orebiča",
        },
        mljet: {
          name: "Národný park Mljet",
          description: "Najzelenjší chorvátsky ostrov s dvoma slanými jazerami, benediktínskym kláštorom na ostrovčeku a nedotknutou prírodou. Ideálne na plávanie, jazdu na kajaku a vychutnanie si pokoja.",
          distance: "1h loďou",
        },
        svIlija: {
          name: "Sv. Ilija - Najvyšší vrch Pelješaca",
          description: "Nezabudnuteľná túra na vrch vo výške 961m s panoramatickým výhľadom na celý polostrov, ostrovy a Jadranské more. Chodník začína v Orebiči borovicovým lesom.",
          distance: "2h túry z Orebiča",
        },
        dubrovnik: {
          name: "Dubrovník",
          description: "Perla Jadranu a pamiatka UNESCO. Prejdite sa po slávnych hradbách, preskúmajte Stradun, navštívte pevnosť Lovrijenac alebo sa osviežte na pláži Banje. Destinácia, ktorú musíte vidieť!",
          distance: "80 min jazdy",
        },
      },
    },
    faq: {
      subtitle: "FAQ",
      title: "Často kladené otázky",
      items: [
        {
          question: "Aké sú časy príchodu a odchodu?",
          answer: "Check-in je od 14:00 do 23:00. Check-out je od 06:00 do 11:00. Prosíme, informujte nás vopred o plánovanom čase príchodu.",
        },
        {
          question: "Môžem prísť so zvieraťom?",
          answer: "Bohužiaľ, domáce zvieratá nie sú v apartmáne povolené.",
        },
        {
          question: "Má apartmán parkovanie?",
          answer: "Áno, apartmán má bezplatné parkovacie miesto pre hostí.",
        },
        {
          question: "Je povolené fajčenie?",
          answer: "Fajčenie nie je v apartmáne povolené. Môžete fajčiť na vonkajšej terase.",
        },
      ],
    },
    contact: {
      subtitle: "Kontakt",
      title: "Kontaktujte nás",
      phone: "Telefón",
      email: "Email",
      whatsapp: "Napíšte nám",
    },
    inquiry: {
      subtitle: "Rezervácia",
      title: "Odoslať dopyt",
      description: "Vyplňte formulár a my sa vám ozveme s ponukou čo najskôr.",
      checkIn: "Dátum príchodu *",
      checkOut: "Dátum odchodu *",
      selectDate: "Vyberte dátum",
      guests: "Počet hostí *",
      selectGuests: "Vyberte počet hostí",
      person: "osoba",
      persons: "osoby",
      fullName: "Celé meno *",
      fullNamePlaceholder: "Vaše celé meno",
      emailLabel: "Email *",
      emailPlaceholder: "vas@email.com",
      message: "Správa (voliteľné)",
      messagePlaceholder: "Ďalšie poznámky alebo otázky...",
      consent: "Súhlasím so spracovaním osobných údajov za účelom spracovania dopytu *",
      submit: "Odoslať dopyt",
      sending: "Odosielanie...",
      successTitle: "Ďakujeme za váš dopyt!",
      successMessage: "Čoskoro sa vám ozveme.",
      errorTitle: "Chyba pri odosielaní dopytu",
      errorMessage: "Skúste to prosím znova alebo nás kontaktujte telefonicky.",
    },
    footer: {
      quickLinks: "Rýchle odkazy",
      contact: "Kontakt",
      rights: "Všetky práva vyhradené.",
      privacy: "Zásady ochrany osobných údajov | Podmienky použitia",
    },
  },
};
